import loadable from "utils/loadable";

export const HalamanMemberArea = loadable(() => import("./index"));
export const HalamanEbook = loadable(() => import("./HalamanEbook"));
export const HalamanVideo = loadable(() => import("./HalamanVideo"));
export const IndexEnableAcces = loadable(() => import("./indexEnableAcces"));
export const MemberAccess = loadable(() => import("./MemberAccess"));
